import { initializeReactWidget } from "~/common/widgets/frontend";
import { BreadcrumbsView } from "./components/BreadcrumbsView";
import config from "../breadcrumbs/widget.json";

// the widget class name is used to identify elements to attach our React component to
// the php widget file uses this same value when rendering the widget container
const widgetClassName = config.name;
initializeReactWidget(widgetClassName, BreadcrumbsView, BreadcrumbsView);
